<template>
  <div class="clearfix rounded pb-5 mx-auto">
    <b-card>
      <div class="d-flex justify-content-between align-items-center mb-3">
        <h5 class="mb-0">Activity Log</h5>

        <div class="d-flex">
          <b-form-select
            v-model="month"
            :options="monthOptions"
            class="mr-2"
            size="sm"
            @change="getActivities"
          />

          <b-form-select
            v-model="year"
            :options="yearOptions"
            size="sm"
            @change="getActivities"
          />
        </div>
      </div>

      <div class="row justify-content-center no-margin">
        <div class="col-sm-12 px-0">
          <b-overlay :show="loading" rounded="sm">
            <div class="employee-table-wrapper table-sticky-height">
              <table class="employee-list-table employee-list-table-leave dataTable table-overflow table-sticky ess-custom-table">
                <thead>
                  <tr class="table-head">
                    <td
                      v-for="column in columns"
                      :key="column.name"
                      @click="sortBy(column.name)"
                      :class="sortKey === column.name ? (sortOrders[column.name] > 0 ? 'sorting_asc' : 'sorting_desc') : 'sorting'"
                      style="cursor:pointer;"
                    >
                      <label class="custom-label">
                        <span>{{ column.label }}</span>
                      </label>
                    </td>
                  </tr>
                </thead>

                <tbody>
                  <template v-if="paginatedData.length > 0">
                    <tr
                      class="table-row hover-bg"
                      v-for="(activity, index) in paginatedData"
                      :key="index"
                    >
                      <td>
                        {{ formatDate(activity.date) }}
                      </td>

                      <td>
                        {{ formatTime(activity.time) }}
                      </td>

                      <td>
                        {{ activity.module || '-' }}
                      </td>

                      <td>
                        {{ activity.action_name || '-' }}
                      </td>
                        <td>
                        {{ activity.activity || '-' }}
                        </td>

                      <td>
                        <b-link
                          v-if="activity.ip_address"
                          @click="showIpLocation(activity.ip_address)"
                        >
                          {{ activity.ip_address }}
                        </b-link>

                        <span v-else>-</span>
                      </td>
                    </tr>
                  </template>

                  <template v-else>
                    <tr class="hover-bg table-row">
                      <td class="cursor-pointer trz_relative text-center" colspan="6">
                        No activity found for this period.
                      </td>
                    </tr>
                  </template>
                </tbody>
              </table>
            </div>

            <div class="mt-2" v-if="filteredData.length > 0">
              <ul class="pagination b-pagination float-left mb-0 mt-1">
                <li class="page-item disabled m-2">View</li>

                <li class="page-item disabled">
                  <b-form-select
                    v-model="temp_length"
                    :options="length_options"
                    @change="setFirstPage"
                  />
                </li>

                <li class="page-item disabled m-2">
                  per page. Total {{ people }} records found.
                </li>
              </ul>

              <b-pagination-nav
                class="float-right mt-1"
                v-model="pagination.currentPage"
                :number-of-pages="pagination.pages"
                prev-text="Previous"
                next-text="Next"
                base-url="#"
                first-number
                last-number
              />
            </div>
          </b-overlay>
        </div>
      </div>

      <b-modal
        id="ip-location-modal"
        title="IP Address Location"
        hide-footer
        size="md"
      >
        <b-overlay :show="ipLocationLoading" rounded="sm">
          <div v-if="ipLocation">
            <table class="table table-sm mb-0">
              <tbody>
                <tr>
                  <th>IP Address</th>
                  <td>{{ selectedIpAddress }}</td>
                </tr>
                <tr>
                  <th>Country</th>
                  <td>{{ ipLocation.country || '-' }}</td>
                </tr>
                <tr>
                  <th>Region</th>
                  <td>{{ ipLocation.region || '-' }}</td>
                </tr>
                <tr>
                  <th>City</th>
                  <td>{{ ipLocation.city || '-' }}</td>
                </tr>
                <tr>
                  <th>ISP</th>
                  <td>{{ ipLocation.isp || ipLocation.org || '-' }}</td>
                </tr>
                <tr>
                  <th>Timezone</th>
                  <td>{{ ipLocation.timezone || '-' }}</td>
                </tr>
                <tr v-if="ipLocation.message">
                  <th>Note</th>
                  <td>{{ ipLocation.message }}</td>
                </tr>
              </tbody>
            </table>
          </div>

          <div v-else class="text-center text-muted py-3">
            No location data found.
          </div>
        </b-overlay>
      </b-modal>
    </b-card>
  </div>
</template>

<script>
import moment from 'moment';

export default {
  name: 'EssActivityLog',

  data() {
    let sortOrders = {};
    let columns = [
      { label: 'Date', name: 'date', type: 'date' },
      { label: 'Time', name: 'time' },
      { label: 'Module', name: 'module' },
      { label: 'Activity Type', name: 'action_name' },
      { label: 'Activity', name: 'activity' },
      { label: 'IP Address', name: 'ip_address' }
    ];

    columns.forEach((column) => {
      sortOrders[column.name] = -1;
    });

    return {
      loading: false,
      activities: [],

      year: moment().year(),
      month: moment().month() + 1,

      columns: columns,
      sortKey: 'date',
      sortOrders: sortOrders,

      search: '',
      length: 20,
      temp_length: 20,
      length_options: [],
      pagination: {
        currentPage: 1,
        pages: 1
      },
      people: 0,

      selectedIpAddress: '',
      ipLocation: null,
      ipLocationLoading: false
    };
  },

  computed: {
    monthOptions() {
      return [
        { value: 1, text: 'January' },
        { value: 2, text: 'February' },
        { value: 3, text: 'March' },
        { value: 4, text: 'April' },
        { value: 5, text: 'May' },
        { value: 6, text: 'June' },
        { value: 7, text: 'July' },
        { value: 8, text: 'August' },
        { value: 9, text: 'September' },
        { value: 10, text: 'October' },
        { value: 11, text: 'November' },
        { value: 12, text: 'December' }
      ];
    },

    yearOptions() {
      let years = [];
      let currentYear = moment().year();

      for (let year = currentYear; year >= currentYear - 5; year--) {
        years.push({
          value: year,
          text: year
        });
      }

      return years;
    },

    filteredData() {
      let filteredList = this.activities || [];

      this.people = filteredList.length;

      this.length_options = [
        { value: 10, text: '10' },
        { value: 20, text: '20' },
        { value: 50, text: '50' },
        { value: 100, text: '100' },
        { value: 200, text: '200' },
        { value: 500, text: '500' },
        { value: filteredList.length || 1, text: 'All' }
      ];

      if (this.search) {
        filteredList = filteredList.filter((row) => {
          return Object.keys(row).some((key) => {
            return String(row[key]).toLowerCase().indexOf(this.search.toLowerCase()) > -1;
          });
        });
      }

      let sortKey = this.sortKey;
      let order = this.sortOrders[sortKey] || 1;

      if (sortKey && sortKey !== 'index') {
        filteredList = filteredList.slice().sort((a, b) => {
          let index = this.getIndex(this.columns, 'name', sortKey);

          if (this.columns[index] && this.columns[index].type === 'date') {
            let aDateTime = moment((a.date || '') + ' ' + (a.time || ''), 'YYYY-MM-DD HH:mm:ss');
            let bDateTime = moment((b.date || '') + ' ' + (b.time || ''), 'YYYY-MM-DD HH:mm:ss');

            return (aDateTime.valueOf() > bDateTime.valueOf() ? 1 : -1) * order;
          }

          let aValue = String(a[sortKey] || '').toLowerCase();
          let bValue = String(b[sortKey] || '').toLowerCase();

          return (aValue === bValue ? 0 : aValue > bValue ? 1 : -1) * order;
        });
      }

      this.pagination.pages = Math.ceil(filteredList.length / this.length) || 1;

      if (this.pagination.currentPage > this.pagination.pages) {
        this.pagination.currentPage = 1;
      }

      return filteredList;
    },

    paginatedData() {
      return this.paginate(this.filteredData, this.length, this.pagination.currentPage);
    }
  },

  mounted() {
    this.getActivities();
  },

  methods: {
    getActivities() {
      this.loading = true;

      axios.get(this.$api_url + `/front/activity-log/${this.year}/${this.month}`)
        .then((response) => {
          this.activities = response.data || [];
          this.resetPagination();
        })
        .catch((error) => {
          console.error(error);
          this.activities = [];

          this.$bvToast.toast('Failed to load activity logs.', {
            title: 'Error',
            variant: 'danger',
            solid: true
          });
        })
        .finally(() => {
          this.loading = false;
        });
    },

    showIpLocation(ipAddress) {
      if (!ipAddress) {
        return;
      }

      this.selectedIpAddress = ipAddress;
      this.ipLocation = null;
      this.ipLocationLoading = true;

      this.$bvModal.show('ip-location-modal');

      axios.get(this.$api_url + '/front/activity-log/ip-location', {
        params: {
          ip: ipAddress
        }
      })
        .then((response) => {
          this.ipLocation = response.data || null;
        })
        .catch((error) => {
          console.error(error);
          this.ipLocation = null;

          this.$bvToast.toast('Failed to load IP location.', {
            title: 'Error',
            variant: 'danger',
            solid: true
          });
        })
        .finally(() => {
          this.ipLocationLoading = false;
        });
    },

    sortBy(key) {
      this.sortKey = key;
      this.sortOrders[key] = this.sortOrders[key] * -1;
      this.resetPagination();
    },

    paginate(data, length, page) {
      let start = (page - 1) * length;
      let end = start + length;

      return data.slice(start, end);
    },

    setFirstPage() {
      this.length = parseInt(this.temp_length);
      this.pagination.currentPage = 1;
      this.pagination.pages = Math.ceil(this.filteredData.length / this.length) || 1;
    },

    resetPagination() {
      this.pagination.currentPage = 1;
      this.pagination.pages = Math.ceil(this.filteredData.length / this.length) || 1;
    },

    getIndex(array, key, value) {
      return array.findIndex((item) => item[key] === value);
    },

    formatDate(value) {
      if (!value) {
        return '-';
      }

      return moment(value, 'YYYY-MM-DD').format('DD MMM YYYY');
    },

    formatTime(value) {
      if (!value) {
        return '-';
      }

      
      return moment(value, 'HH:mm:ss').format('hh:mm:ss A');
    }
  }
};
</script>